<mat-card (click)="$event.stopPropagation()"
          (contextmenu)="showContextMenu($event)"
          (mousedown)="onMouseDown($event)"
          (mousemove)="onMouseMove()"
          (mouseup)="onMouseUp($event)"
          [class.docked-left]="taskList.posX === 0"
          [class.docked-top]="taskList.posY === 49"
          [style.background-color]="taskList.backgroundColor"
          [style.color]="taskList.foregroundColor"
          [cbHighlightColor]="taskList.backgroundColorGradient"
          [cbHighlightedItem]="taskList"
          data-cy="task-list">
  <mat-card-title *ngIf="taskList.header" data-cy="task-list-header">
    {{ taskList.header }}
  </mat-card-title>
  <mat-card-content (cdkDropListDropped)="dropItem($event)" [cdkDropListData]="taskList.items" cdkDropList>
    <ng-container *ngFor="let item of taskList.items">
      <span cdkDrag class="flex-container task-list-item" style="margin: 0" data-cy="task-list-task">
        <span [style.display]="item === itemToEdit ? 'contents' : 'block'">
          <ng-container *ngIf="item.isSubTask">
            <button (click)="toggleSubTask(item)" class="item-button" mat-icon-button
                    [attr.aria-label]="'MOVE_TO_LEFT' | translate"
                    style="margin-left: -6px">
              <mat-icon>remove</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="!item.isSubTask">
            <button (click)="toggleSubTask(item)" class="item-button" mat-icon-button
                    [attr.aria-label]="'MOVE_TO_RIGHT' | translate"
                    style="margin-left: -34px">
              <mat-icon>arrow_right</mat-icon>
            </button>
          </ng-container>
          <mat-checkbox (change)="dataService.cacheData()" [(ngModel)]="item.checked">
            <ng-container *ngIf="item !== itemToEdit">
              <div *ngIf="stringParser.containsLink(item.value)" [innerHTML]="stringParser.convert(item.value)"></div>
              <div *ngIf="!stringParser.containsLink(item.value)" [innerText]="stringParser.convert(item.value)"></div>
            </ng-container>
          </mat-checkbox>
          <button *ngIf="item !== itemToEdit" (click)="addItemAfter(item)" class="item-button" mat-icon-button
                  [attr.aria-label]="'ADD_TASK' | translate">
            <mat-icon>add</mat-icon>
          </button>
          <input *ngIf="item === itemToEdit" (keydown)="onKeyPressed($event, item)" (mousedown)="$event.stopPropagation()"
                 [(ngModel)]="item.value" cbAutofocus data-cy="task-list-task-input">
        </span>
        <span *ngIf="item !== itemToEdit">
          <button (click)="startEditItem(item)" class="item-button" mat-icon-button
                  [attr.aria-label]="'EDIT' | translate"
                  data-cy="task-list-task-edit-btn">
            <mat-icon>edit</mat-icon>
          </button>
          <button (click)="deleteItem(item)" class="item-button" mat-icon-button
                  [attr.aria-label]="'DELETE' | translate" style="margin-right: -8px"
                  data-cy="task-list-task-delete-btn">
            <mat-icon>delete</mat-icon>
          </button>
        </span>
        <button *ngIf="item === itemToEdit && item.value" (click)="endEditItem(item)"
                class="item-button with-grow-animation" mat-icon-button
                [attr.aria-label]="'SELECT' | translate" style="margin-right: -8px">
          <mat-icon>check</mat-icon>
        </button>
        <button *ngIf="item === itemToEdit && !item.value" (click)="endEditItem(item)"
                class="item-button with-grow-animation" mat-icon-button
                [attr.aria-label]="'CANCEL' | translate" style="margin-right: -8px">
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </ng-container>
  </mat-card-content>

  <mat-card-actions align="end">
    <button (click)="addItem()" mat-icon-button [attr.aria-label]="'ADD' | translate" data-cy="task-list-add-btn">
      <mat-icon>add</mat-icon>
    </button>
    <button (click)="edit()" mat-icon-button [attr.aria-label]="'EDIT' | translate" data-cy="task-list-edit-btn">
      <mat-icon>edit</mat-icon>
    </button>
    <button (click)="delete(); $event.stopPropagation()" mat-icon-button
            [attr.aria-label]="'DELETE' | translate" data-cy="task-list-delete-btn">
      <mat-icon>delete</mat-icon>
    </button>
    <button (click)="showContextMenu($event)" mat-icon-button [attr.aria-label]="'MORE' | translate"
            data-cy="task-list-more-btn">
      <mat-icon>more_vert</mat-icon>
    </button>
  </mat-card-actions>
  <mat-card-footer [style.margin-bottom.px]="-32"></mat-card-footer>
</mat-card>

<div [matMenuTriggerFor]="contextMenu"
     [style.left.px]="rightClickPosX"
     [style.top.px]="rightClickPosY"
     style="visibility: hidden; position: fixed">
</div>
<mat-menu #contextMenu="matMenu">
  <div [style.background]="taskList.backgroundColorGradient
            ? 'linear-gradient(to bottom, ' + taskList.backgroundColor + ', ' + taskList.backgroundColorGradient
            : taskList.backgroundColor"
       [style.color]="taskList.foregroundColor">
    <button *ngIf="!taskList.selected" (click)="select()" mat-menu-item
            [attr.aria-label]="'SELECT' | translate">
      <mat-icon>check</mat-icon>
      {{ 'SELECT' | translate }}
    </button>

    <button *ngIf="taskList.selected" (click)="select()" mat-menu-item
            [attr.aria-label]="'REMOVE_SELECTION' | translate">
      <mat-icon>close</mat-icon>
      {{ 'REMOVE_SELECTION' | translate }}
    </button>

    <ng-container *ngIf="!dataService.selectedItemsCount">
      <button (click)="edit()" mat-menu-item
              [attr.aria-label]="'EDIT' | translate">
        <mat-icon>edit</mat-icon>
        {{ 'EDIT' | translate }}
      </button>

      <button (click)="delete()" mat-menu-item
              [attr.aria-label]="'DELETE' | translate">
        <mat-icon>delete</mat-icon>
        {{ 'DELETE' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="!dataService.selectedItemsCount">
      <button [matMenuTriggerFor]="movement" mat-menu-item
              [attr.aria-label]="'MOVE' | translate">
        <mat-icon>auto_awesome_motion</mat-icon>
        {{ 'MOVE' | translate }}
      </button>

      <ng-container *ngIf="dataService.tabs.length > 1">
        <button [matMenuTriggerFor]="tabs" mat-menu-item
                [attr.aria-label]="'SEND_TO_TAB' | translate">
          <mat-icon>tab</mat-icon>
          {{ 'SEND_TO_TAB' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="dataService.getColorizedObjects(taskList).length > 1">
        <button [matMenuTriggerFor]="coloredItems" mat-menu-item
                [attr.aria-label]="'COPY_COLOR_FROM' | translate">
          <mat-icon>colorize</mat-icon>
          {{ 'COPY_COLOR_FROM' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="dataService.itemsCount > 1">
        <button [matMenuTriggerFor]="connectableItems" mat-menu-item
                [attr.aria-label]="'CONNECT_TO' | translate">
          <mat-icon>cable</mat-icon>
          {{ 'CONNECT_TO' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="dataService.getColorizedObjects(taskList).length === 1">
        <button (click)="copyColorFrom(dataService.getColorizedObjects(taskList)[0])" mat-menu-item
                [attr.aria-label]="'COPY_OTHER_COLOR' | translate">
          <mat-icon>colorize</mat-icon>
          {{ 'COPY_OTHER_COLOR' | translate }}
        </button>
      </ng-container>

      <button (click)="addItem()" mat-menu-item
              [attr.aria-label]="'ADD_TASK' | translate">
        <mat-icon>add</mat-icon>
        {{ 'ADD_TASK' | translate }}
      </button>
    </ng-container>
  </div>
</mat-menu>

<mat-menu #movement="matMenu">
  <div [style.background]="taskList.backgroundColorGradient
            ? 'linear-gradient(to bottom, ' + taskList.backgroundColor + ', ' + taskList.backgroundColorGradient
            : taskList.backgroundColor"
       [style.color]="taskList.foregroundColor">
    <button (click)="dataService.bringToFront(taskList)" mat-menu-item
            [attr.aria-label]="'BRING_TO_FRONT' | translate">
      <mat-icon>flip_to_front</mat-icon>
      {{ 'BRING_TO_FRONT' | translate }}
    </button>
    <button (click)="dataService.bringForward(taskList)" mat-menu-item
            [attr.aria-label]="'BRING_FORWARD' | translate">
      <mat-icon>add_circle_outline</mat-icon>
      {{ 'BRING_FORWARD' | translate }}
    </button>
    <button (click)="dataService.sendBackward(taskList)" mat-menu-item
            [attr.aria-label]="'SEND_BACKWARD' | translate">
      <mat-icon>remove_circle_outline</mat-icon>
      {{ 'SEND_BACKWARD' | translate }}
    </button>
    <button (click)="dataService.flipToBack(taskList)" mat-menu-item
            [attr.aria-label]="'SEND_TO_BACK' | translate">
      <mat-icon>flip_to_back</mat-icon>
      {{ 'SEND_TO_BACK' | translate }}
    </button>
  </div>
</mat-menu>

<mat-menu #tabs="matMenu">
  <div [style.background]="taskList.backgroundColorGradient
            ? 'linear-gradient(to bottom, ' + taskList.backgroundColor + ', ' + taskList.backgroundColorGradient
            : taskList.backgroundColor"
       [style.color]="taskList.foregroundColor">
    <ng-container *ngFor="let tab of dataService.tabs">
      <button (click)="moveToTab(tab.index)" *ngIf="dataService.selectedTabIndex !== tab.index" mat-menu-item
              [attr.aria-label]="'SEND_TO_TAB' | translate">
        <mat-icon>arrow_forward</mat-icon>
        {{tab.label ? tab.label : '#Board ' + (tab.index + 1)}}
      </button>
    </ng-container>
  </div>
</mat-menu>

<mat-menu #coloredItems="matMenu">
  <ng-container *ngFor="let item of dataService.getColorizedObjects(taskList)">
    <button (click)="copyColorFrom(item)" *ngIf="taskList !== item" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'COPY_COLOR_FROM' | translate">
      <mat-icon>color_lens</mat-icon>
      <ng-container *ngIf="!item.backgroundColorGradient">
        {{item.backgroundColor}}
      </ng-container>
      <ng-container *ngIf="item.backgroundColorGradient">
        {{ item.backgroundColor + ' → ' + item.backgroundColorGradient }}
      </ng-container>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #connectableItems="matMenu">
  <ng-container *ngFor="let item of dataService.tab.notes">
    <button (click)="connectTo(item)" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{taskList.connectedTo?.includes(item.id) ? 'close' : 'note'}}</mat-icon>
      {{DisplayValue.fromNote(item)}}
    </button>
  </ng-container>
  <ng-container *ngFor="let item of dataService.tab.noteLists">
    <button (click)="connectTo(item)" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{taskList.connectedTo?.includes(item.id) ? 'close' : 'sticky_note_2'}}</mat-icon>
      {{DisplayValue.fromNoteList(item)}}
    </button>
  </ng-container>
  <ng-container *ngFor="let item of dataService.tab.taskLists">
    <button (click)="connectTo(item)" *ngIf="taskList !== item" [style.background]="item.backgroundColorGradient
                ? 'linear-gradient(to bottom, ' + item.backgroundColor + ', ' + item.backgroundColorGradient
                : item.backgroundColor"
            [style.color]="item.foregroundColor"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate">
      <mat-icon>{{taskList.connectedTo?.includes(item.id) ? 'close' : 'list'}}</mat-icon>
      {{DisplayValue.fromTaskList(item)}}
    </button>
  </ng-container>
  <ng-container *ngFor="let item of dataService.tab.images">
    <button (click)="connectTo(item)"
            mat-menu-item [attr.aria-label]="'CONNECT_TO' | translate"
            [style.background]="'var(--color-note)'">
      <mat-icon>{{taskList.connectedTo?.includes(item.id) ? 'close' : 'link'}}</mat-icon>
      {{DisplayValue.fromImage(item)}}
    </button>
  </ng-container>
  <button *ngIf="taskList.connectedTo" (click)="connectTo(undefined)"
          mat-menu-item [attr.aria-label]="'CONNECT_TO_NOTHING' | translate"
          [style.background]="'var(--color-note)'">
    <mat-icon>link_off</mat-icon>
    {{'CONNECT_TO_NOTHING' | translate}}
  </button>
</mat-menu>
